<div class="lx-page-header">
  <div>
    <p class="lx-page-eyebrow">{{ 'delivery.management' | translate }}</p>
    <h2 class="lx-page-title">{{ 'delivery.title' | translate }}</h2>
  </div>
</div>

<!-- ── Add Region Card ── -->
<div class="app-card lx-section-card">
  <div class="lx-section-header">
    <span class="material-symbols-outlined">add_location_alt</span>
    <h3 class="lx-section-title">{{ 'delivery.add_region' | translate }}</h3>
  </div>
  <form [formGroup]="addForm" (ngSubmit)="add()" class="delivery-form">
    <div class="delivery-field-group">
      <label class="lx-label">{{ 'lbl.name' | translate }} *</label>
      <input formControlName="name" type="text" class="lx-input" [placeholder]="'ph.region_name' | translate" />
    </div>
    <div class="delivery-field-group">
      <label class="lx-label">{{ 'delivery.name_ar' | translate }}</label>
      <input formControlName="name_ar" type="text" class="lx-input" placeholder="اسم المنطقة" dir="rtl" />
    </div>
    <div class="delivery-field-group">
      <label class="lx-label">{{ 'delivery.price' | translate }} *</label>
      <input formControlName="price" type="number" min="0" class="lx-input" [placeholder]="'ph.price' | translate" />
    </div>
    <div class="delivery-form-action">
      <button type="submit" class="lx-btn lx-btn--primary" [disabled]="addForm.invalid">
        <span class="material-symbols-outlined">add</span>
        {{ 'btn.add' | translate }}
      </button>
    </div>
  </form>
</div>

<!-- ── Regions Table ── -->
<div class="app-card lx-section-card">
  <div class="lx-section-header">
    <span class="material-symbols-outlined">local_shipping</span>
    <h3 class="lx-section-title">{{ 'delivery.regions' | translate }}</h3>
  </div>

  <div class="lx-empty-state" *ngIf="regions.length === 0">
    {{ 'empty.delivery_regions' | translate }}
  </div>

  <div class="lx-table-wrap" *ngIf="regions.length > 0">
    <table class="lx-table">
      <thead>
        <tr>
          <th>#</th>
          <th>{{ 'lbl.name' | translate }}</th>
          <th>{{ 'delivery.name_ar' | translate }}</th>
          <th>{{ 'delivery.price' | translate }}</th>
          <th>{{ 'lbl.action' | translate }}</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let r of regions">
          <ng-container *ngIf="editingRegion?.id !== r.id">
            <td class="cell-muted">{{ r.id }}</td>
            <td>{{ r.name }}</td>
            <td dir="rtl">{{ r.name_ar || '—' }}</td>
            <td class="cell-price">{{ r.price }} <span class="cell-currency">LE</span></td>
            <td class="cell-actions">
              <button class="lx-icon-btn" (click)="openEdit(r)" [title]="'btn.edit' | translate">
                <span class="material-symbols-outlined">edit</span>
              </button>
              <button class="lx-icon-btn lx-icon-btn--danger" (click)="delete(r.id)" [title]="'btn.delete' | translate">
                <span class="material-symbols-outlined">delete</span>
              </button>
            </td>
          </ng-container>

          <!-- Inline edit row -->
          <ng-container *ngIf="editingRegion?.id === r.id" [formGroup]="editForm">
            <td class="cell-muted">{{ r.id }}</td>
            <td><input formControlName="name" type="text" class="lx-input lx-input--sm" /></td>
            <td><input formControlName="name_ar" type="text" class="lx-input lx-input--sm" dir="rtl" /></td>
            <td><input formControlName="price" type="number" min="0" class="lx-input lx-input--sm" style="width:80px" /></td>
            <td class="cell-actions">
              <button class="lx-icon-btn lx-icon-btn--success" (click)="saveEdit()" [title]="'btn.save' | translate">
                <span class="material-symbols-outlined">check</span>
              </button>
              <button class="lx-icon-btn" (click)="cancelEdit()" [title]="'btn.cancel' | translate">
                <span class="material-symbols-outlined">close</span>
              </button>
            </td>
          </ng-container>
        </tr>
      </tbody>
    </table>
  </div>
</div>
